import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import qs from 'query-string';

function DeleteBannerModal({ t, onClose, visible, cityName, deleteBanner, bannerData }) {
  const { cityId } = qs.parse(window.location.search);

  const [deleteType, setDeleteType] = useState();
  const currentScope = useMemo(() => {
    if (bannerData.allCountries) {
      setDeleteType('ALL_COUNTRIES');
      return 'All countries';
    }
    if (!bannerData.allCountries && bannerData.country) {
      setDeleteType('COUNTRY');
      return bannerData.country.name;
    }
    if (!bannerData.allCountries && bannerData.cities.length > 1) {
      setDeleteType('MANY_CITIES');
      return `${bannerData.cities.length} cities`;
    }
    setDeleteType('CITY');
    return cityName;
  }, [bannerData]);

  const handleDeleteBanner = type => {
    let deleteParams = {
      id: bannerData.id,
    };

    switch (type) {
      case 'CITY':
        // 如果allCountries为false或cities大于一个或country存在，证明不是只有一个删除按钮
        deleteParams = Object.assign(deleteParams, {
          cityId,
          allDelete:
            bannerData.allCountries || bannerData.cities?.length > 1 || bannerData.country?.id
              ? false
              : true,
        });
        break;
      case 'ALL_COUNTRIES':
        deleteParams = Object.assign(deleteParams, {
          allCountries: bannerData.allCountries,
          allDelete: true,
        });
        break;
      case 'COUNTRY':
        deleteParams = Object.assign(deleteParams, {
          countryId: bannerData?.country?.id,
          allDelete: true,
        });
        break;
      case 'MANY_CITIES':
        deleteParams = Object.assign(deleteParams, {
          cities: bannerData.cities.map(item => ({ cityId: item.id })),
          allDelete: true,
        });
        break;
    }

    deleteBanner({ variables: { input: deleteParams } });
    onClose();
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      width={456}
      wrapClassName="delete-banner-modal"
      footer={null}
      centered
      maskClosable={false}
    >
      <div className="modal-wrapper">
        <div className="title">{t('Are you sure to delete this banner?')}</div>
        <div className="main-section">Banner application scope: {currentScope}</div>
        <Button className="delete-btn" onClick={() => handleDeleteBanner('CITY')}>
          {deleteType === 'CITY' ? 'Delete banner' : `Delete only the banner of ${cityName}`}
        </Button>
        <Choose>
          <When condition={deleteType === 'ALL_COUNTRIES'}>
            <Button className="delete-all-btn" onClick={() => handleDeleteBanner('ALL_COUNTRIES')}>
              Delete this banner from all countries
            </Button>
          </When>
          <When condition={deleteType === 'COUNTRY'}>
            <Button className="delete-all-btn" onClick={() => handleDeleteBanner('COUNTRY')}>
              {`Delete this banner from ${bannerData.country.name}`}
            </Button>
          </When>
          <When condition={deleteType === 'MANY_CITIES'}>
            <Button className="delete-all-btn" onClick={() => handleDeleteBanner('MANY_CITIES')}>
              Delete this banner from all cities
            </Button>
          </When>
        </Choose>
      </div>
    </Modal>
  );
}

DeleteBannerModal.propTypes = {
  t: PropTypes.func,
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};

DeleteBannerModal.defaultProps = {
  t: () => {},
  onClose: () => {},
  visible: false,
};

export default DeleteBannerModal;
